import { Link } from 'react-router-dom';
import { mangaList } from '@/mocks/mangaData';

export default function FeaturedManga() {
  const featured = mangaList.filter((m) => m.featured).slice(0, 5);

  return (
    <section className="w-full py-10 md:py-14 px-4 md:px-6 bg-background-100/50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-100 font-heading">推荐作品</h2>
            <p className="text-sm text-foreground-500 mt-1">编辑精选热门漫画</p>
          </div>
          <Link
            to="/category/all"
            className="text-sm text-primary-500 hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap flex items-center gap-1"
          >
            更多推荐 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5" data-product-shop="">
          {featured.map((manga) => (
            <Link
              key={manga.id}
              to={`/article/${manga.id}`}
              className="group cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
                <img
                  src={manga.cover}
                  alt={manga.title}
                  title={`${manga.title} - h漫画在线阅读`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
                  <span className="text-xs text-foreground-100 bg-primary-500 px-2 py-1 rounded whitespace-nowrap">立即阅读</span>
                </div>
                <div className="absolute top-2 left-2">
                  <span className="bg-accent-500 text-background-950 text-xs font-bold px-2 py-1 rounded whitespace-nowrap">
                    {manga.rating}
                  </span>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-200 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1">
                {manga.title}
              </h3>
              <p className="text-xs text-foreground-600 mt-1">{manga.author}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}